<template>
    <el-card class="reportsList">
        <div style=" font-size: 16px;
        font-weight: 900;">二线事件管理报表</div>
        <ul>
            <router-link :to="{path:'/acceptEvents',query:{groupType:'second'}}">
                <li>二线团队受理＋处理事件统计</li>
            </router-link>
            <router-link :to="{path:'/satisfactionRate',query:{groupType:'second'}}">
                <li>客户满意度合格率</li>
            </router-link>
            <router-link :to="{path:'/exceedSLA',query:{groupType:'second'}}">
                <li>超出SLA的事件的数量</li>
            </router-link>
        </ul>
    </el-card>
</template>

<script>
    export default {
        name: "firstLineEvent"
    }
</script>

<style scoped>
    .reportsList{
        /*height: 120px;*/
        background: white;
        font-size: 15px;
    }
    .reportsList div{
        padding-left: 15px;
    }
    .reportsList ul{
        float: left;
        margin: 20px 10px 10px 10px;

    }
    .reportsList ul li{
        color: grey;
        float: left;
        margin: 5px 35px 5px 5px;
    }
</style>
